var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 26,
    viewBox: "0 0 91 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5525 2.91547C44.5525 3.1258 44.5525 5.57965 44.5525 5.57965H37.8255C37.8255 5.57965 37.8255 3.1258 37.8255 2.91547C37.6108 2.91547 33.4243 2.91547 33.1738 2.91547C33.1738 3.16085 33.1738 11.8545 33.1738 11.8545C33.1738 11.9246 33.1738 13.8176 35.1776 13.8176C35.1776 13.8176 48.9179 13.8176 49.1684 13.8176C49.1684 13.5722 49.1684 3.16085 49.1684 2.91547C48.9537 2.91547 44.7672 2.91547 44.5525 2.91547ZM44.5525 11.0483H37.8255V8.31395H44.5525V11.0483Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1145 2.91559C58.1145 3.16097 58.1145 13.5022 58.1145 13.7476C57.8999 13.7476 53.6776 13.7476 53.4629 13.7476C53.4629 13.5373 53.4629 11.9248 53.4629 11.9248C53.4629 11.9248 50.8866 11.9248 50.6719 11.9248C50.6719 11.7144 50.6719 9.43584 50.6719 9.22551C50.8866 9.22551 53.4629 9.22551 53.4629 9.22551V7.47275C53.4629 7.47275 50.8866 7.47275 50.6719 7.47275C50.6719 7.26242 50.6719 4.94879 50.6719 4.73845C50.8866 4.73845 53.4629 4.73845 53.4629 4.73845C53.4629 4.73845 53.4629 3.12592 53.4629 2.91559C53.6776 2.91559 57.8641 2.91559 58.1145 2.91559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1139 15.4651C58.1139 15.7105 58.1139 23.3525 58.1139 23.5628C57.8992 23.5628 53.4623 23.5628 53.4623 23.5628V18.1994H33.1738V15.4651C33.1738 15.4651 57.8634 15.4651 58.1139 15.4651Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1374 15.4651C70.1374 15.7105 70.1374 20.8286 70.1374 20.8286C70.1374 20.8286 88.1357 20.8286 88.3862 20.8286C88.3862 21.0389 88.3862 23.3525 88.3862 23.5629C88.1357 23.5629 67.5253 23.5629 67.5253 23.5629C65.5215 23.5629 65.5215 21.6699 65.5215 21.5998C65.5215 21.5998 65.5215 16.3415 65.5215 15.4651C65.7004 15.4651 69.8869 15.4651 70.1374 15.4651Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0353 1.44318L75.9336 5.08891L77.2218 3.54648L83.6984 11.5391V2.91549H88.35V7.89332H90.819V10.6276H88.35V19.2161H83.6984V13.7826H80.3706L74.6813 6.7365L68.9919 13.7826H63.0879L73.0353 1.44318Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.791016 25.5259H26.1247L11.6688 13.2567L0.791016 25.5259Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.817 9.85635L20.0769 3.89699L26.1599 9.08514V0.70697H0.826172V18.3747L11.1314 6.70139L14.817 9.85635Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5061 9.78625L18.0371 12.5907L26.1596 19.4965V14.6239L20.5061 9.78625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36);
export default __webpack_public_path__ + "static/media/36.6ac7adb86b1bb08adda56528bed0b7ae.svg";
export { ForwardRef as ReactComponent };